// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'project.page.title': 'Projects',
    'project.page.archive.title': 'Archived Projects',
    'project.page.bin.title': 'Binned Projects',
    'project.page.search_results': 'Search Results',
    'project.page.create.title': 'Create New Project',
    'project.page.search.title': 'Find Projects',
    'project.page.edit.title': 'Edit Project',
    'project.page.view.title': 'View Project',
    'project.page.all': 'All',

    'project.button.cancel': 'Cancel',
    'project.button.select': 'Select',
    'project.button.find': 'Find Projects',
    'project.button.search': 'Apply',
    'project.button.create': 'Create Project',
    'project.button.new': 'New Project',
    'project.button.save': 'Save Changes',
    'project.button.archive': 'Archive Project',
    'project.button.bin': 'Bin Project',
    'project.button.empty': 'Empty Bin',
    'project.button.delete': 'Permanently Delete',
    'project.button.edit': 'Edit',
    'project.button.restore': 'Restore',
    'project.button.reset': 'Reset',
    'project.button.convert_to_template': 'Create as Template',

    'project.placeholder.search': 'Search projects',

    'project.link.create_first_project': 'Click here to create your first project',
    'project.link.projects': ' Return to Projects',
    'project.link.archive': 'Archived Projects',
    'project.link.bin': 'Binned Projects',
    'project.link.retry': 'Click here to retry',
    'project.link.edit': 'Edit Project',

    'project.checkbox.all': 'Check All',
    'project.checkbox.actions_label': 'with selected',

    'project.label.project_type_name': 'Project Type',
    'project.label.entity_name': 'Client',
    'project.label.title': 'Title',
    'project.label.description': 'Description',
    'project.label.start_date': 'Start Date',
    'project.label.end_date': 'End Date',
    'project.label.status': 'Status',

    'project.sort.field_label': 'Field',
    'project.sort.direction_label': 'Direction',
    'project.sort.direction_ascending': 'Ascending',
    'project.sort.direction_descending': 'Descending',

    'project.modal.title.project_archive': 'Archive Project',
    'project.modal.title.project_bin': 'Bin Project',
    'project.modal.title.project_bin_empty': 'Delete All Binned Projects',
    'project.modal.title.project_delete_permanently': 'Delete Project',
    'project.modal.title.project_restore': 'Restore Project',
    'project.modal.title.project_to_template': 'Create as Template ',

    'project.modal.message.project_to_template': 'You are about to create a template from this project. This will include active checklists and tasks.',
    'project.modal.message.project_archive': 'Are you sure that you want to move this project to the archive ? | Are you sure that you want to move these projects to the archive ?',
    'project.modal.message.project_bin': 'Are you sure that you want to move this project to the bin ? | Are you sure that you want to move these projects to the bin ?',
    'project.modal.message.project_bin_empty': 'Are you sure that you want to permanently delete all binned projects? This action cannot be undone!',
    'project.modal.message.project_delete_permanently':
        'Are you sure that you want to permanently delete this project? This action cannot be undone. | Are you sure that you want to permanently delete these projects? This action cannot be undone.',
    'project.modal.message.project_restore': 'Are you sure that you want to restore this project? | Are you sure that you want to restore these projects?',

    'project.success.message.project_created': 'Your project has been created',
    'project.success.message.project_updated': 'Your project has been updated',
    'project.success.message.project_restored': 'Your project has been restored | All selected projects were restored',
    'project.success.message.project_deleted': 'Your project has been permanently deleted | All selected projects were permanently deleted',
    'project.success.message.archived_projects': 'Your project was moved to the archive | All selected projects were moved to the archive',
    'project.success.message.binned_projects': 'Your project was moved to the bin | All selected projects were moved to the bin',
    'project.success.message.project_bin_emptied': 'All binned projects were permanently deleted!',

    'project.error.message.archived_projects': 'This project was already moved to the archive | These projects were already moved to the archive',
    'project.error.message.binned_projects': 'This project was already moved to the bin | These projects were already moved to the bin',
    'project.error.message.project_bin_emptied': 'All binned projects were already deleted',
    'project.error.message.project_deleted': 'This project was already permanently deleted | These projects were already permanently deleted',
    'project.error.message.project_restored': 'This project was already restored | These projects were already restored',
    'project.error.message.error_loading_page': 'Sorry, there was an error loading project.| Sorry, there was an error loading projects.',

    'project.message.search.no_archived_projects': "You don't have any archived projects.",
    'project.message.search.no_binned_projects': "You don't have any binned projects.",
};
